import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import React from "react";

export default function InputTextArea({ message = null, name = null, placeholder = "", label = "", type = "text", value = "", onChange = null, disabled = false, required = false }) {
    return (
        <div className="p-fluid">
            {label} {required ? <span style={{ color: "red" }}>*</span> : ""}
            {/* <div style={{ visibility: "hidden" }}>LOGO</div>   */}
            <InputTextarea  autoComplete="off" name={name} placeholder={placeholder} value={value} onChange={onChange} disabled={disabled} />
            <small style={{ width: "100%" }} className="p-error">
                {message !== null && message[name]}
            </small>
        </div>
    );
}


export  function InputNum({ message = null, name = null, placeholder = "", label = "", type = "text", value = "", onChange = null, disabled = false, required = false }) {
    return (
        <div className="p-fluid">
            {label} {required ? <span style={{ color: "red" }}>*</span> : ""}
            {/* <div style={{ visibility: "hidden" }}>LOGO</div>   */}
            <InputText max={2} maxLength={2}  autoComplete="off" name={name} placeholder={placeholder} value={Math.abs(parseInt(value))||0} onChange={e=>{
                onChange(e)
            }} disabled={disabled} />
            <small style={{ width: "100%" }} className="p-error">
                {message !== null && message[name]}
            </small>
        </div>
    );
}